module.exports = __webpack_public_path__ + "static/media/Logo_TELUS_en.de905e32.png";